import React from 'react';

export const NoWorriesStep: React.FC = () => {
  return (
    <img
      src="/images/coverage.png"
      alt="Coverage illustration"
      className="w-full h-full object-cover object-right-top"
    />
  );
};
